import { io } from 'socket.io-client';

// Single shared socket for the whole app, authenticated the same way as the REST
// API (utils/api.js) — the JWT from localStorage, sent via the handshake `auth`
// payload so server.js can verify it before letting a socket join any room.
// Lazily connected: only pages that need live data (e.g. TrainerSchedulesPage)
// call connect(), so idle pages don't hold a socket open.
const socket = io({
  autoConnect: false,
  auth: (cb) => cb({ token: localStorage.getItem('sms_token') }),
});

export default socket;
